var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { VisitorPlaceMapComponent } from '../place.map/visitor.place.map.component';
var CustomPlaceBtnComponent = /** @class */ (function (_super) {
    __extends(CustomPlaceBtnComponent, _super);
    function CustomPlaceBtnComponent(formBuilder, router, activatedRoute, allFrontendSettingsStore, editorChoiceStore, visitorCalendarStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.isHideEditorChoice = false;
        _this.editorChoiceText = "EDITOR'S CHOICE";
        _this.command = new VisitorCalendarActionCommand();
        _this.customPlaces = [];
        _this.selectedCustomPlace = null;
        _this.mode = 'topbar';
        _this.onCustomPlaceSelected = new EventEmitter();
        return _this;
    }
    CustomPlaceBtnComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, customPlaceBtnId = _a.customPlaceBtnId;
        this.hubName = hubName;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.customSettings) {
                _this.isHideEditorChoice = command.customSettings.isHideEditorChoice || false;
                _this.customPlaces = command.customSettings.customPlaces || null;
                // if this is a custom place btn URL, set the selection status
                if (customPlaceBtnId) {
                    var customBtnInUrl_1 = _this.customPlaces.find(function (x) { return x._id === customPlaceBtnId; });
                    console.log('customBtnInUrl', customBtnInUrl_1);
                    if (customBtnInUrl_1) {
                        setTimeout(function () {
                            _this.createCustomBtnCommand(customBtnInUrl_1);
                        });
                    }
                }
            }
        });
        this.editorChoiceTextHandler();
        this.command.isMapView = this.activatedRoute.component === VisitorPlaceMapComponent;
    };
    CustomPlaceBtnComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (editorChoice) {
            _this.editorChoiceText = editorChoice.editorChoiceForPlace || "EDITOR'S CHOICE";
        });
    };
    CustomPlaceBtnComponent.prototype.clearFilter = function () {
        this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
        this.selectedCustomPlace = null;
        // localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
    };
    CustomPlaceBtnComponent.prototype.setFilter = function (title, isEditorChoice) {
        if (isEditorChoice === void 0) { isEditorChoice = false; }
        this.customPlaceAccordion && this.customPlaceAccordion.setFilter(title);
        this.selectedCustomPlace = this.customPlaces.find(function (x) { return x.btnText === title; });
        console.log('selectedCustomPlace', this.selectedCustomPlace);
        isEditorChoice && (this.command.queryCommand.choice = true);
    };
    CustomPlaceBtnComponent.prototype.close = function () {
        this.customPlaceAccordion && this.customPlaceAccordion.close();
    };
    CustomPlaceBtnComponent.prototype.editChoice = function () {
        this.command.queryCommand.search = null;
        this.command.queryCommand.category = null;
        this.command.queryCommand.choice = true;
        this.command.queryCommand.isCustom = null;
        this.command.isEventCalendar = false;
        this.command.queryCommand.selectedPlaces = null;
        this.command.queryCommand.customPlaceBtnText = this.editorChoiceText;
        this.selectedCustomPlace = null;
        localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(this.command));
        this.visitorCalendarStore.actionCommand.next(this.command);
        // visitor.components.ts uses this to handle browser's back button event
        this.customPlaceAccordion && this.customPlaceAccordion.setFilter(this.editorChoiceText);
        this.mode === 'topbar' && this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.onCustomPlaceSelected.emit(this.command);
    };
    CustomPlaceBtnComponent.prototype.getFeedPlace = function (custom) {
        this.createCustomBtnCommand(custom);
        this.visitorCalendarStore.actionCommand.next(this.command);
        if (!this.command.isMapView) {
            this.router.navigateByUrl(
            // getRouteUrl(routeConfigs.visitor.placeCalendar, {
            //     hubName: this.hubName,
            //     category: 'all',
            // }),
            getRouteUrl(routeConfigs.visitor.customPlace, {
                hubName: this.hubName,
                customPlaceBtnId: custom._id,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        this.mode === 'topbar' && this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.onCustomPlaceSelected.emit(custom);
    };
    CustomPlaceBtnComponent.prototype.all = function () {
        localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
        this.command.isEventCalendar = false;
        this.command.queryCommand.choice = false;
        this.command.queryCommand.search = null;
        this.command.queryCommand.isCustom = null;
        this.command.isEventCalendar = false;
        this.selectedCustomPlace = null;
        this.command.queryCommand.category = 'All';
        if (!this.command.isMapView) {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
                hubName: this.hubName,
                category: this.command.queryCommand.category,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
        this.mode === 'topbar' && this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.onCustomPlaceSelected.emit(this.command);
    };
    CustomPlaceBtnComponent.prototype.createCustomBtnCommand = function (custom) {
        this.command.queryCommand.choice = false;
        this.command.queryCommand.search = null;
        this.command.queryCommand.category = null;
        this.command.queryCommand.isCustom = true;
        this.command.queryCommand.categoryList = null;
        this.command.queryCommand.type = custom._id;
        this.command.isEventCalendar = false;
        this.command.queryCommand.selectedPlaces = undefined;
        this.command.queryCommand.customPlaceBtnText = custom.btnText;
        localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(this.command));
        this.selectedCustomPlace = custom;
        this.customPlaceAccordion && this.customPlaceAccordion.setFilter(custom.btnText);
    };
    return CustomPlaceBtnComponent;
}(BaseComponent));
export { CustomPlaceBtnComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/custom.place.btn/custom.place.btn.component.ts.pre-build-optimizer.js